import UniversalTilt from './universal-tilt';

export default UniversalTilt;
exports['default'] = UniversalTilt;
module.exports = exports['default'];
